import { FaMapMarkerAlt, FaTags, FaCalendarAlt, FaUsers, FaHourglass, FaUserCog } from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'leaddesigner':
      return <FaUserCog />; // Leader icon

    default: 
      return null; // Return null if no matching icon is found
  }

};